import script from "./rec-plain-text.vue?vue&type=script&lang=ts&setup=true"
export * from "./rec-plain-text.vue?vue&type=script&lang=ts&setup=true"

const __exports__ = script;

export default __exports__